import { EyeIcon, EyeOffIcon } from '../../Brand/Icon';
import React, { useEffect, useState } from "react";
import config from '../../../utils/config';
import { setLocalStorage, getLocalStorage } from '../../../utils/func';
import { useTranslation } from 'react-i18next';
import '../index.scss';

export default function ButtonGlaz({disabled, value, onChange}) {
    const { t } = useTranslation();
    const [privat, setPrivat] = useState(() => getLocalStorage(config.privat) === 'true');
    const disableClass = disabled ? 'button-disable' : '';
    const selected = value ?? privat;

    useEffect(() => {
        if (getLocalStorage(config.privat) == null) setLocalStorage(config.privat, false);
    }, []);

    const togglePrivat = () => {
        if (disabled) return;
        if (onChange) { onChange(!selected); return; }
        const privat_flg = (getLocalStorage(config.privat)) ? (getLocalStorage(config.privat) === "true") : false;
        setPrivat(!privat_flg);
        setLocalStorage(config.privat, !privat_flg);
    }

    return (
        <button type="button" className="wiw-icon-button" onClick={togglePrivat} disabled={disabled}
            aria-label={t('user.private_opinion', { defaultValue: 'Private opinion' })} aria-pressed={selected}>
            { selected === true ?
                <EyeOffIcon className={`nav-icon ${disableClass}`} aria-hidden="true" />
                :
                <EyeIcon className={`nav-icon ${disableClass}`} aria-hidden="true" />
            }
        </button>
    )
}
